<template>
    <div>
        <h5>
            {{ label }}
            <v-chip v-if="required" class="ma-2" x-small outlined color="primary">{{$t("form.mandatory")}}</v-chip>
        </h5>
        <v-row>
            <v-col>
                <v-radio-group row :value="selected" @change="updateValue">
                    <v-radio
                        v-for="option in options"
                        :key="option.value"
                        :label="option.text"
                        :value="option.value"
                        :required="required"
                        :readonly="readonly"
                    ></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        required: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        value(newValue) {
            console.log("Value changed: ", newValue);
            this.selected = newValue;
        },
        selected(newValue) {
            console.log("Emitting value: ", newValue);
            this.$emit('input', newValue);
        }
    },
    methods: {
        updateValue(value) {
            console.log("Updating value: ", value);
            this.selected = value;
        }
    },
    data(){
        return {
            selected: this.value
        }
    },
    mounted(){
        this.selected = this.value;
    }
};
</script>